import { InfoCircleOutlined } from '@ant-design/icons'
import { Card, Flex, Statistic, StatisticProps, Tooltip, Typography } from 'antd'
import React from 'react'

import s from './statistic-number.module.css'

const { Text } = Typography

export interface StatisticNumberBlockProps extends StatisticProps {
  title: string;
  value?: number | string
  tooltip?: string;
}

export default function StatisticNumber(
  { title, value = 0, tooltip, ...restProps }: StatisticNumberBlockProps,
) {

  return (
    <Card variant='borderless' className={s.statisticNumber}>
      <Statistic
        title={
          <Flex className={s.titleBlock}>
            <Text type="secondary" className={s.title}>{title}</Text>
            {tooltip &&
              <Tooltip title={tooltip}>
                <Text type="secondary">
                  <InfoCircleOutlined />
                </Text>
              </Tooltip>}
          </Flex>
        }
        value={value}
        precision={2}
        {...restProps}
      />
    </Card>
  )
}